import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        position: 'relative' as const,
        flexGrow: 1
    },
    backButton: {
        position: 'absolute' as const,
        top: '-.75rem',
        left: '1rem'
    },
    accountAdditionalInfoContainer: {
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        padding: '.75rem 0',
        marginTop: '-1rem'
    },
    accountStatisticsPanel: {
        width: 'auto' as const,
        maxHeight: '40vh',
        overflowY: 'auto' as const,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '1rem 2.5rem',
        '@media (min-height: 920px)': { maxHeight: '50vh' }
    },
    accountTransactionHistoryPanel: {
        height: 'fit-content' as const,
        flexBasis: 'auto' as const,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '1.5rem'
    },
    accountUsersPanel: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '1rem 2.5rem'
    },
    panelHeader: {
        color: theme?.app?.applicationColors.enumColors.black ||
            '#000000',
        fontSize: '.8rem',
        textTransform: 'uppercase' as const,
        alignSelf: 'flex-start' as const
    },
    statisticWithLabel: { paddingTop: '2.5rem' },
    statisticWithLabelSmallPadding: { paddingTop: '1rem' },
    statContainer: { paddingBottom: '16px' }
});